import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';
import { createSlug } from '../../util/urlHelpers';
import { isListingOnline } from '../../util/presence';
import { listingBookingLinkProps } from '../../util/bookingIntent';
import { usePublicOffers, listenerOffersFree } from '../FirstSessionFree/FirstSessionFree';
import css from './MatchMeButton.module.css';

/**
 * "Not sure who to pick?" (Sam, Oct 21 2026, TEST): picks an Available now
 * listener (free-session listeners first, then top-rated) and opens Talk Now.
 */
export const pickMatch = ({ listings = [], presenceMap = {}, busyMap = {}, pausedMap = {}, reviewStats = {}, offers = null }) => {
  const free = l => (offers && listenerOffersFree(offers, l?.author?.id?.uuid) ? 1 : 0);
  const st = l => reviewStats[l?.id?.uuid] || { average: 0, count: 0 };
  const now = listings.filter(
    l => l?.id?.uuid && isListingOnline(l.id.uuid, presenceMap, l) && !busyMap[l.id.uuid] && !pausedMap[l.id.uuid]
  );
  now.sort((a, b) => free(b) - free(a) || st(b).average - st(a).average || st(b).count - st(a).count);
  return now[0] || null;
};

const MatchMeButton = props => {
  const { className } = props;
  const history = useHistory();
  const routes = useRouteConfiguration();
  const offers = usePublicOffers();
  const [none, setNone] = useState(false);
  const go = () => {
    const pick = pickMatch({ ...props, offers });
    try {
      require('../../util/talkerFunnel').trackTalkerFunnel('match_me_tap', { listingId: pick?.id?.uuid, detail: pick ? 'matched' : 'none' });
    } catch (e) {
      // ignore
    }
    if (!pick) {
      setNone(true);
      return;
    }
    const id = pick.id.uuid;
    const link = listingBookingLinkProps({ id, slug: createSlug(pick.attributes?.title || ''), mode: 'now' });
    history.push(createResourceLocatorString(link.name, routes, link.params, {}) + (link.to?.search || '') + (link.to?.hash || ''), link.to?.state);
  };
  return (
    <div className={[css.root, className].filter(Boolean).join(' ')} data-match-me="true">
      <button type="button" className={css.btn} onClick={go} data-match-me-btn="true">
        Not sure who to pick? We’ll match you with someone available now
      </button>
      {none ? (
        <p className={css.none} role="status">
          No one is available this minute. Pick a listener below and book a time, or check back soon.
        </p>
      ) : null}
    </div>
  );
};

export default MatchMeButton;
